import { Table } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const MuiTable = withStyles((theme) => ({
  root: {
    borderCollapse: 'separate',
    borderSpacing: '0 0.5rem',
  },
}))(Table);

export default MuiTable;
